import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { getRailsUpdate } from "@/common/utils/getRailsUpdate";
import { mapToDeletion } from "@/common/utils/railsHelpers";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { MaintenanceSpecificationValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema";

interface UseUpdateEstablishmentCompanyMaintenanceSpecificationProps {
  establishmentCompanyId: string;
  maintenanceSpecification: EstablishmentCompanyData['maintenance_specifications'][number];
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const useUpdateEstablishmentCompanyMaintenanceSpecification = ({
  establishmentCompanyId,
  maintenanceSpecification,
  onSuccess,
  onError,
}: UseUpdateEstablishmentCompanyMaintenanceSpecificationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentCompanyMaintenanceSpecification'],
    mutationFn: (data: MaintenanceSpecificationValidationSchema) => {
      const payload = {
        maintenance_specifications_attributes: [
          {
            id: maintenanceSpecification.id,
            equipment_category_specifications_attributes: getRailsUpdate(
              maintenanceSpecification.equipment_category_specifications || [],
              data.equipment_category_specifications_attributes || [],
              (x) => x.category_id,
              (y) => y.value,
              mapToDeletion,
              (z) => ({ category_id: z.value }),
            ),
            equipment_manufacturer_specifications_attributes: getRailsUpdate(
              maintenanceSpecification.equipment_manufacturer_specifications || [],
              data.equipment_manufacturer_specifications_attributes || [],
              (x) => x.manufacturer.id,
              (y) => y.value,
              mapToDeletion,
              (z) => ({ manufacturer_id: z.value }),
            ),
            system_specifications_attributes: getRailsUpdate(
              maintenanceSpecification.system_specifications || [],
              data.system_specifications_attributes || [],
              (x) => x.system_id,
              (y) => y.value,
              mapToDeletion,
              (z) => ({ system_id: z.value }),
            ),
          },
        ],
      }

      return privateAxios.put(`/establishment/companies/${establishmentCompanyId}/update_maintenance_models`, {
        company: payload,
      });
    },
    onSuccess,
    onError,
  })
}
